import React from "react";
import PageTitle from "components/PageTitle";
import RankingFeedbacks from "components/RankingFeedbacks";

const FeedbacksDashboard: React.FC = () => (
  <>
    <PageTitle
      breadCrumbItems={[
        {
          label: "Ranking de Feedbacks",
          path: "/feedbacks-dashboard",
        },
      ]}
      mdiIcon={"book-account-outline"}
      title={"Ranking de Feedbacks"}
    />

    <RankingFeedbacks />
  </>
);

export default FeedbacksDashboard;
